import React, { useEffect } from 'react';

// Components

import CommonModalContainer from './CommonModalContainer';
import DashboardModalContainer from '../individualPortal/dashboard/DashboardModalContainer';
import ModalContainer from '../individualPortal/modalContainer';
import LceModalContainer from '../lce/LceModalContainer';
import SsapModalContainer from '../ssap/SsapModalContainer';
import TicketMgmtModalContainer from '../ticketMgmtPortal/TicketMgmtModalContainer';
import FallbackUIModal from '@common-components/modals/FallbackUIModal';
import EntityModalContainer from '../entity/EntityModalContainer';

// Hooks

import { useAnchors } from '@hooks/useAnchors';

// Utils

import { modalTools } from '@utils/tools/modalTools';
import { preventerTools } from '@utils/tools/preventerTools';


const ModalAccessibilityWrapper = props => {

    const {
        commonActions,
        formName,
        modalBoundary,
        modalBoundaryClassName,
        modal,
        modalType,
        modalsList,
        modalsQty
    } = props;



    const containerName = modalTools.getContainerNameByModalType(modalsList, modalType);

    const {
        modalId,
        modalHeaderTextData
    } = modalTools.getModalFromConfigsByModalType(modalsList, modalType);

    const actions = {
        hideAllModals: () => commonActions.hideAllModals(),
        hideModal: () => commonActions.hideModal(modalType),
        showModal: modalConfig => commonActions.showModal(modalConfig)
    };

    const bottomAnchors = useAnchors(3);
    const topAnchors = useAnchors(3);
    const [ primaryTopAnchor, ...secondaryTopAnchors ] = topAnchors;

    const focusOnAnchor = anchors => {
        let executed = false;
        anchors.forEach(a => {
            if(a.current && !executed) {
                a.current.focus();
                executed = !executed;
            }
        });
        executed = !executed;
    };

    useEffect(() => {

        const focusOutListener = e => {

            const {
                dataset: {
                    modaltype: containerModalType
                }
            } = [ ...document.getElementsByClassName(modalBoundaryClassName) ].pop();

            function checkParent(node) {

                const {
                    modaltype: nodeModalType
                } = preventerTools.provideObject(node.dataset, null, true);

                if(!node.parentNode) {
                    return false;
                }
                if(nodeModalType === containerModalType) {
                    return true;
                }
                if(node.parentNode) {
                    return checkParent(node.parentNode);
                }
            }

            if(e.relatedTarget === null) {
                return null;
            } else if (!checkParent(e.relatedTarget)) {
                focusOnAnchor(topAnchors);
            }
        };

        modalBoundary.current && modalBoundary.current.addEventListener('focusout', focusOutListener);

        const keyDownListener = e => {
            if(e.shiftKey && e.keyCode === 9 && topAnchors.some(a => a.current === e.target)) {
                e.preventDefault();
                focusOnAnchor(bottomAnchors);
            }
        };

        modalBoundary.current && modalBoundary.current.addEventListener('keydown', keyDownListener);

        focusOnAnchor(topAnchors);

    }, [ modalsQty ]);

    const boundAnchor = modalTools.boundAnchor;

    const hideModal = actions.hideModal;

    const extendedProps = {
        actions,
        bottomAnchors,
        boundAnchor,
        formName,
        modal,
        modalHeaderProps: {
            modalId,
            modalHeaderTextData,
            hideModal,
            primaryTopAnchor
        },
        secondaryTopAnchors
    };

    switch(containerName) {

        case 'common':
            return <CommonModalContainer { ...extendedProps }/>;

        case 'dashboard':
            return <DashboardModalContainer { ...extendedProps }/>;

        case 'individualPortal':
            return <ModalContainer { ...extendedProps }/>;

        case 'lce':
            return <LceModalContainer { ...extendedProps }/>;

        case 'ssap':
            return <SsapModalContainer { ...extendedProps }/>;

        case 'ticketMgmt':
            return <TicketMgmtModalContainer { ...extendedProps }/>;
        
        case 'entity':
            return <EntityModalContainer { ...extendedProps } />;

        default:
            return <FallbackUIModal { ...extendedProps }/>;
    }
};

export default ModalAccessibilityWrapper;
